import request from '@comm/utils/request'
const priPrefix = 'priconversion'
// const priLogin = 'login' // 'prilogin'
const priLogin = 'prilogin' // 'prilogin'
const priInvoice = 'invoice'
const preConversion = 'conversion'

/**
 * @description:  登录
 * @return {String} 返回token
 */
export function login (data) {
  return request({
    url: `sysuser/loginIn/v1`,
    method: 'post',
    data
  })
}

/**
 * @description: 微信登录绑定手机号
 */
export function wxLoginBindPhone (data) {
  return request({
    url: `/${priLogin}/login/bindMobile`,
    method: 'post',
    data
  })
}

/**
 * @description: 获取微信二维码登录 state
 */
export function wxState (params) {
  return request({
    url: `/${priLogin}/login/wx/state`,
    method: 'get',
    params
  })
}

/**
 * @description: 获取个人中心二维码 state
 */
export function wxCenterState (params) {
  return request({
    url: `/${priLogin}/user/wx/state`,
    method: 'get',
    params
  })
}

/**
 * @description: 解除绑定微信号
 */
export function wxUnbind (data) {
  return request({
    url: `/${priLogin}/user/wx/unbind`,
    method: 'post',
    data
  })
}

/**
 * @description: 获取用户信息
 */
export function getInfo () {
  return request({
    url: `sysuser/getUserInfo/v1`,
    method: 'post'
  })
}

/**
 * @description: wps获取用户信息和token
 */
 export function getWpsUserInfo (data) {
  return request({
    url: `/pubwpslogin/api/v1/user/wpsOpen/getWpsOpenUserInfoByCode`,
    method: 'post',
    data
  })
}

/**
 * @description: id换用户头像
 */
export function getPicImg (id) {
  return request({
    url: `/pridocument/${id}`,
    method: 'get'
  })
}

/**
 * @description: 登出
 */
export function logout (data) {
  return request({
    url: 'sysuser/logout/v1',
    method: 'post',
    data
  })
}

/**
 * @description: wps登出
 */
 export function logoutWps () {
  return request({
    url: `/pubwpslogin/api/v1/user/wpsOpen/loginOut`,
    method: 'post'
  })
}

/**
 * @description: 注册
 */
export function registerUser (data) {
  return request({
    url: `/${priLogin}/user/register`,
    method: 'post',
    data
  })
}

/**
 * @description: 重置密码
 */
export function updatePwd (data) {
  return request({
    url: `/${priLogin}/user/setPassWord`,
    method: 'post',
    data
  })
}

/**
 * @description: 智能验证
 */
export function validationApi (data) {
  return request({
    url: `/${priLogin}/login/sendAliyunVerify`,
    method: 'post',
    data
  })
}

/**
 * @description: 获取轻阅读地址
 */
export function getWebUrl () {
  return request({
    url: `conversion/management/getReaderUrl`,
    method: 'get'
  })
}

/**
 * @description: 获取用户空间信息空间
 */
export function getUserSpaceInfo () {
  return request({
    url: `/sysuser/getUserSpaceSizeInfo/v1`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/comm/api/public-user/user.js